import { render, staticRenderFns } from "./OwnershipOverview.vue?vue&type=template&id=4e6f45bb&"
import script from "./OwnershipOverview.vue?vue&type=script&lang=js&"
export * from "./OwnershipOverview.vue?vue&type=script&lang=js&"
import style0 from "./OwnershipOverview.vue?vue&type=style&index=0&id=4e6f45bb&prod&lang=scss&"
import style1 from "../../../node_modules/v-calendar/lib/v-calendar.min.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports